import { render, staticRenderFns } from "./StatisticPage3.vue?vue&type=template&id=7b752240&scoped=true"
import script from "./StatisticPage3.vue?vue&type=script&lang=js"
export * from "./StatisticPage3.vue?vue&type=script&lang=js"
import style0 from "./StatisticPage3.vue?vue&type=style&index=0&id=7b752240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b752240",
  null
  
)

export default component.exports